import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, ErrorHandler, Injector } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LtbUsageComponent } from './ltb-usage/ltb-usage.component';
import { NgIdleModule } from '@ng-idle/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpService } from './services/http.service';
import { CanDeactivateGuard } from './shared/guards/can-deactivate.guard';
import { SnEnvService, SnEnvModule } from '@insight/serenity-env';
import { PermissionsService } from './shared/services/permissions.service';
import { SnAuthService, SnAuthInterceptor, SnAuthModule, SnOktaConfigProvider, snPreInitServiceFactory } from '@insight/serenity-auth';
import { AppInsightsService } from './shared/services/app-insights.service';
import { BulkUsageComponent } from './bulk-usage/bulk-usage.component';
import { AggregationModule } from './aggregation/aggregation.module';
import { TitleService } from './shared/services/title.service';
import { TwoDigitDecimaNumberDirective } from './shared/Directives/two-digit-decimal.directive';
import { FilePortalModule } from './file-portal/file-portal.module';
import { DataFileConfigutationModule } from './data-file-configutation/data-file-configutation.module';
import { SharedDataService } from './shared/services/shared-data.service';
import { SharedComponentsModule } from './shared/components/shared-components.module';
import { HttpModule } from '@angular/http';
import { ClientBillingBackupFileConfigurationService } from './shared/services/http/ClientBillingBackupFileConfiguration.service';
import { ManualUsageLandingComponent } from './ltb-usage/manual-usage-landing/manual-usage-landing.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DataGridModule } from './angular-packages/data-grid/data-grid.module';
import { SettingsService } from './shared/services/user-settings.service';
import { UserService } from './shared/services/user.service';
import { LtbManualFormComponent } from './ltb-usage/ltb-manual-form/ltb-manual-form.component';
import { ApiModule } from './shared/api/api.module';
import { PersonaGuard } from './auth/authguards/persona-guard';
import { WrongPersonasComponent } from './auth/wrong-personas/wrong-personas.component';
import { GlobalErrorHandler } from './global-error-handler';
import { SharedPipesModule } from './shared/pipes/shared-pipes.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { ClientConfigModule } from './client-config/client-config.module';
import { OktaAuthModule } from '@okta/okta-angular';
import { PreInitService } from './pre-init.service';
import { SnScaffoldingModule } from '@insight/serenity-scaffolding';
import { ConfirmationDialogComponent } from './bulk-usage/confirm-dialog/confirm-dialog.component';

@NgModule({
  declarations: [
    AppComponent,
    LtbUsageComponent,
    BulkUsageComponent,
    TwoDigitDecimaNumberDirective,
    ManualUsageLandingComponent,
    LtbManualFormComponent,
    WrongPersonasComponent,
    ConfirmationDialogComponent
  ],
  imports: [
    NgIdleModule.forRoot(),
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AggregationModule,
    FilePortalModule,
    DataFileConfigutationModule,
    DataGridModule,
    NgxDatatableModule,
    NgbModule,
    SnAuthModule,
    OktaAuthModule,
    SnEnvModule.forRoot({ envUrl: 'assets/environments/environment.json' }),
    SharedComponentsModule,
    HttpModule,
    ApiModule,
    NgSelectModule,
    SharedPipesModule,
    ClientConfigModule,
    AppRoutingModule,
    SnScaffoldingModule
  ],
  providers: [
    HttpService,
    Title,
    PermissionsService,
    UserService,
    CanDeactivateGuard,
    SnAuthService,
    SnEnvService,
    TitleService,
    AppInsightsService,
    SharedDataService,
    SettingsService,
    ClientBillingBackupFileConfigurationService,
    PersonaGuard,
    { provide: HTTP_INTERCEPTORS, useClass: SnAuthInterceptor, multi: true },
    { provide: APP_INITIALIZER, useFactory: snPreInitServiceFactory, deps: [PreInitService, Injector, SnEnvService], multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    PreInitService,
    SnOktaConfigProvider
  ],
  bootstrap: [
    AppComponent
  ],
  entryComponents: [ConfirmationDialogComponent]
})
export class AppModule { }
